import { gql } from 'graphql-tag';
import {
  MEMBER_FRAGMENT,
  NOT_COUPON_MEMBERSHIPPLAN_FRAGMENT,
  USER_COUPON_FRAGMENT,
} from '../fragments';

/**
 * 更新用户信息
 */
export const fetchUpdateUserDocument = gql`
  mutation updateCustomer($input: UpdateCustomerInput!) {
    updateCustomer(input: $input) {
      id
    }
  }
`;

/**
 * 查询用户会员信息
 */
export const fetchGetUserMemberDocument = gql`
  query getUserMember {
    getUserMember {
      ...Member
    }
  }
  ${MEMBER_FRAGMENT}
`;

/**
 * 购买会员
 */
// export const fetchPurchaseMembershipDocument = gql`
//   mutation purchaseMembership($membershipPlanId: ID!, $paymentType: WeChatPaymentType) {
//     purchaseMembership(membershipPlanId: $membershipPlanId, paymentType: $paymentType) {
//       status
//       appId
//       timeStamp
//       nonceStr
//       package
//       signType
//       paySign
//     }
//   }
// `;

/**
 * 使用会员优惠
 */
export const fetchApplyMemberDocument = gql`
  mutation applyMember($orderId: ID) {
    applyMember(orderId: $orderId) {
      id
    }
  }
`;

/**
 * 取消使用会员优惠
 */
export const fetchCancelMemberDocument = gql`
  mutation cancelMember($orderId: ID) {
    cancelMember(orderId: $orderId) {
      id
    }
  }
`;

/**
 * 获取最大优惠的会员卡信息
 */
export const fetchMaxDiscountMembershipPlanDocument = gql`
  query maxDiscountMembershipPlan {
    maxDiscountMembershipPlan {
      ...MembershipPlan
    }
  }
  ${NOT_COUPON_MEMBERSHIPPLAN_FRAGMENT}
`;

/**
 * 获取购卡记录
 */
export const fetchMembershipOrdersDocument = gql`
  query membershipOrders($options: MembershipOrderListOptions) {
    membershipOrders(options: $options) {
      items {
        id
        createdAt
        updatedAt
        code
        state
        paymentMethod
        amount
        metadata
        payTime
        member {
          ...Member
        }
        membershipPlan {
          ...MembershipPlan
        }
      }
      totalItems
    }
  }
  ${NOT_COUPON_MEMBERSHIPPLAN_FRAGMENT}
  ${MEMBER_FRAGMENT}
`;

/**
 * 根据会员卡id查询商品数据
 */
export const fetchProductVariantToMembershipIdDocument = gql`
  query productVariantToMembershipId($membershipId: ID!) {
    productVariantToMembershipId(membershipId: $membershipId) {
      id
      price
      productId
    }
  }
`;

/**
 * 查询用户虚拟币余额数据
 */
export const fetchVirtualCurrencyBalanceDocument = gql`
  query getVirtualCurrencyBalance($virtualCurrencyCode: VirtualCurrencyCode!) {
    getVirtualCurrencyBalance(virtualCurrencyCode: $virtualCurrencyCode)
  }
`;

/**
 * 获取购物金配置
 */
export const fetchShoppingCreditsConfigDocument = gql`
  query getShoppingCreditsConfig {
    getShoppingCreditsConfig {
      id
      customPageId
      shoppingCreditsRule
      channelId
    }
  }
`;

/**
 * 领取新客福利
 */
export const fetchReceiveFirstCustomerBenefitDocumenet = gql`
  mutation receiveFirstCustomerBenefit($id: ID!) {
    receiveFirstCustomerBenefit(id: $id) {
      ...UserCoupon
    }
  }
  ${USER_COUPON_FRAGMENT}
`;

/**
 * 微信登录
 */
export const fetchLoginExternalDocument = gql`
  mutation loginExternal($args: ExternalLoginMutationArgs) {
    loginExternal(args: $args) {
      token
      openIdKey
    }
  }
`;

/**
 * 验证码登录
 */
export const fetchPhoneLoginDocument = gql`
  mutation phoneLogin($args: PhoneLoginArgs!) {
    phoneLogin(args: $args) {
      token
      openIdKey
    }
  }
`;

/**
 * 获取微信手机号
 */
export const fetchWechatPhoneDocument = gql`
  mutation getWechatPhone($args: GainPhone!) {
    getWechatPhone(args: $args) {
      token
      openIdKey
    }
  }
`;

/**
 * 发送验证码
 */
export const fetchSendCodeDocument = gql`
  mutation sendCode($phone: String!, $areaCode: String) {
    sendCode(phone: $phone, areaCode: $areaCode) {
      code
      message
    }
  }
`;

/**
 * 获取会员等级
 */
export const fetchGetOwnCustomLevelDocument = gql`
  query getOwnCustomlevel {
    getOwnCustomlevel {
      id
      level
      activated
      nextLevelConditios {
        condition {
          type
          value
          range {
            unit
            value
          }
        }
        conditionValues {
          tradeAmount
          tradeCount
        }
        passed
      }
      distributeRecords {
        type
        couponId
        value
        sourceId
      }
    }
  }
`;

/**
 * 获取会员等级配置
 */
export const fetchGetLevelConfigDocument = gql`
  query getLevelConfig {
    getLevelConfig {
      id
      levelsConfig {
        levels {
          name
          image
          description
          conditions {
            items {
              type
              value
              range {
                unit
                value
              }
            }
            judgeMethod
          }
          rights {
            type
            couponId
            value
          }
        }
      }
      customPageId
      enabled
    }
  }
`;

